module.exports = __webpack_public_path__ + "img/United Kingdom.8a99333b.svg";